import { Injectable } from '@angular/core';
import { ParishConfig } from 'src/models/parishConfig';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class ParishConfigService {
    constructor(private router: Router) { }
    private currentParish: ParishConfig = null

    setCurrentParishConfig(parish: ParishConfig) {
        localStorage.setItem("currentparish", JSON.stringify(parish));

        setTimeout(() => {
            this.router.navigate(['/home']);
        }, 200);
    }

    getCurrentParishConfig() {
        if (this.currentParish) {
            return this.currentParish;
        }

        let strParishConfig = localStorage.getItem("currentparish");
        this.currentParish = strParishConfig ? JSON.parse(strParishConfig) as ParishConfig : null;
        return this.currentParish;
    }

    clearCurrentParishConfig() {
        localStorage.removeItem("currentparish");
    }
}